import React from 'react';
import { useDoorCrewCard } from './DoorCrewCardContext';

interface SeatActionsProps {
  seatId: number;
  onDeleteSeat: () => void;
  showUnassign?: boolean;
}

export default function SeatActions({
  seatId,
  onDeleteSeat,
  showUnassign = true,
}: SeatActionsProps) {
  const { onUnassignSeat } = useDoorCrewCard();

  return (
    <div className="line-item seat-actions">
      {showUnassign && (
        <button
          type="button"
          className="seat-action-link"
          onClick={() => onUnassignSeat(seatId)}
          title="Unassign canvasser"
        >
          <i className="fas fa-user-slash" />
          Unassign
        </button>
      )}
      <button
        type="button"
        className="seat-action-link"
        onClick={onDeleteSeat}
        title="Delete seat"
      >
        <i className="fas fa-trash" />
        Delete
      </button>
    </div>
  );
}
